import { EventEmitter, Injectable } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { campsenum } from '../../../models/enums.generated';
import { CampsSecurityService } from '../../../../infrastructure/infrastructure.module';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class CampsDetailsFormStateService {
    private editedForm: UntypedFormGroup = null;

    public copy: UntypedFormGroup = null;

    //this emiter is used just to trigger change detection in all components
    public updated: EventEmitter<boolean> = new EventEmitter();

    public sessionRemoved: EventEmitter<UntypedFormGroup> = new EventEmitter(); //todo find better way, maybe refresh whole UI and get rid of it

    public sessionChanged: EventEmitter<string> = new EventEmitter();

    public discountChanged: EventEmitter<string> = new EventEmitter();

    public campStatus: campsenum.CampStatus;

    public campType: campsenum.CampType;

    constructor(private security: CampsSecurityService) {}

    public setStatus(campStatus: campsenum.CampStatus) {
        this.campStatus = campStatus;
    }

    public setType(campType: campsenum.CampType) {
        this.campType = campType;
    }

    public get canEdit(): Observable<boolean> {
        return this.security
            .canManageCamps()
            .pipe(
                map(
                    canManage =>
                        canManage &&
                        this.campStatus !== campsenum.CampStatus.Closed &&
                        this.campStatus !== campsenum.CampStatus.Removed
                )
            );
    }

    // in case there will be another right for managing camp care
    public get canEditCampCare(): Observable<boolean> {
        return this.security
            .canManageCamps()
            .pipe(
                map(
                    canManage =>
                        canManage &&
                        this.campStatus !== campsenum.CampStatus.Closed &&
                        this.campStatus !== campsenum.CampStatus.Removed
                )
            );
    }

    public markAsEdited(form: UntypedFormGroup) {
        var copy = this.copyFormControl(form);
        this.copy = copy as UntypedFormGroup;

        this.editedForm = form;
        this.updated.emit(true);
    }

    public finishEdit(form: UntypedFormGroup, save: boolean = true) {
        this.editedForm = null;

        if (!save) {
            form.controls = this.copy.controls;
        }

        // this.copy = null;

        this.updated.emit(false);
    }

    public isEdited(form: UntypedFormGroup) {
        return this.editedForm == form;
    }

    public isOtherItemEdited(form: UntypedFormGroup) {
        return this.editedForm && this.editedForm != form;
    }

    public isAnyItemEdited() {
        return this.editedForm;
    }

    public clear() {
        this.editedForm = null;
        this.copy = null;
    }

    public isChildcareCamp() {
        return this.campType === campsenum.CampType.Childcare;
    }

    copyFormControl(control: AbstractControl) {
        if (control instanceof UntypedFormControl) {
            return new UntypedFormControl(control.value, control.validator, control.asyncValidator);
        } else if (control instanceof UntypedFormGroup) {
            const copy = new UntypedFormGroup({});
            Object.keys(control.getRawValue()).forEach(key => {
                copy.addControl(key, this.copyFormControl(control.controls[key]));
            });
            return copy;
        } else if (control instanceof UntypedFormArray) {
            const copy = new UntypedFormArray([]);
            control.controls.forEach(control => {
                copy.push(this.copyFormControl(control));
            });
            return copy;
        }
    }
}
